import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. PAGO' htmlFor='date-fecha' md={4} size='sm' />
      <Col md={8}>
        <Field name='fecha'>
          {({ field }) => <Form.InputDate {...field} id='date-fecha' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFormGroup)
